import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyDbf-pQbAiFL1C1BaFXlhWrnoJ73SS9gZo",
  authDomain: "geprc-b1c90.firebaseapp.com",
  projectId: "geprc-b1c90",
  storageBucket: "geprc-b1c90.firebasestorage.app",
  messagingSenderId: "195865325815",
  appId: "1:195865325815:web:6d32f275fef8561be423f2",
  measurementId: "G-WJWT3W1D3F"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);

export default app;

